// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_featured-collection.scss';

// -------------------------------------
// Variables
// -------------------------------------
var NAV_SELECTOR = '[data-nav-item]';
var CAROUSEL_SELECTOR = '[data-carousel]';
var CAROUSEL_SECTION_CLASS = 'featured-collection';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '[data-pagination]';
var carousels = document.querySelectorAll(CAROUSEL_SELECTOR);
var navItems = document.querySelectorAll(NAV_SELECTOR);

// -------------------------------------
// Hooks
// -------------------------------------
carousels.forEach((carousel, index) => {
  // Generate unique btn classes for slider arrows
  var prevEl = carousel.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR);
  var nextEl = carousel.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR);
  var paginationEl = carousel.querySelector(CAROUSEL_PAGINATION_SELECTOR);
  carousel.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));
  var handle = carousel.getAttribute('data-carousel');
  var navItem = document.querySelector("[data-nav-item=\"".concat(handle, "\"]"));
  var swiper = new Swiper(carousel, {
    // Optional parameters
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 1.2,
    spaceBetween: 4,
    observer: true,
    observeParents: true,
    a11y: false,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.

    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4.1,
        spaceBetween: 8
      }
    },
    pagination: {
      el: paginationEl,
      type: 'progressbar'
    },
    navigation: {
      nextEl,
      prevEl
    }
  });
  swiper.slides.forEach(function (slide, index) {
    var slideLink = slide.querySelector('a');
    slideLink.addEventListener('focus', function () {
      swiper.slideTo(index);
    });
  });

  // No nav is rendered when only one collection is configured
  if (navItem) {
    navItem.addEventListener('click', function () {
      navItems.forEach(item => item.classList.toggle("".concat(CAROUSEL_SECTION_CLASS, "__carousel-nav-item--selected"), item === this));
      carousels.forEach(carousel => carousel.classList.add('visually-hidden'));
      carousel.classList.remove('visually-hidden');
    });
  }
});